export default __webpack_public_path__ + "static/media/icon-standort-weltweit.d7426fa6.svg";